
      import ArrowRight from './arrow-right.vue'
      import type { App, Plugin } from 'vue'

      export const ArrowRightPlugin: Plugin = {
        install(app: App) {
          app.component('ArrowRight', ArrowRight)
        },
      }
      export { ArrowRight }
      